module.exports = __webpack_public_path__ + "img/cupomDescontoFill.159d31a8.svg";